import React from "react";

export default function SummaryNotGenrated({ CloseSummaryShowToday, close }) {
  return (
    <div className="ContainerStudyPlaner">
      <div className="SubContainerStudyPlanerDCM ">
        <div>
          <div className="TotalimgSummary">
            <img src="/DCM-img/fileImgSumaary1.png" alt=""></img>
            <img
              className="fileImgSumaary2"
              src="/DCM-img/fileImgSumaary2.png"
              alt=""
            ></img>
          </div>
          <div className="d-flex justify-content-center textsumaryOkay mt-4">
            Summary of the class has not been generated yet.<br></br>
            Try again after a few moments.
          </div>
          <div className="d-flex justify-content-center mt-3">
            <button
              className="okayBtnSummary"
              onClick={() => {
                close();
                CloseSummaryShowToday();
              }}
            >
              Okay
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
